// Newsletter form enhancement
document.addEventListener('DOMContentLoaded', function() {
  const newsletterForm = document.querySelector('.newsletter-form');
  
  if (newsletterForm) {
    const emailInput = newsletterForm.querySelector('input[name="contact[email]"]');
    const submitButton = newsletterForm.querySelector('.newsletter-submit-btn');
    const inputSection = newsletterForm.querySelector('.newsletter-input-section');
    const successSection = newsletterForm.querySelector('.newsletter-success-section');
    
    // Enhanced email validation
    function validateEmail(email) {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      return emailRegex.test(email);
    }
    
    // Real-time validation
    if (emailInput) {
      emailInput.addEventListener('input', function() {
        const email = this.value.trim();
        const isValid = email === '' || validateEmail(email);
        
        if (isValid) {
          this.style.borderColor = '';
          this.setCustomValidity('');
        } else {
          this.style.borderColor = '#dc3545';
          this.setCustomValidity('Please enter a valid email address');
        }
      });
    }
    
    // Form submission handling
    newsletterForm.addEventListener('submit', function(e) {
      const email = emailInput ? emailInput.value.trim() : '';
      
      if (!email) {
        e.preventDefault();
        showErrorMessage('Please enter your email address');
        return;
      }
      
      if (!validateEmail(email)) {
        e.preventDefault();
        showErrorMessage('Please enter a valid email address');
        return;
      }
      
      // Disable submit button to prevent double submission
      if (submitButton) {
        submitButton.disabled = true;
        submitButton.textContent = 'Joining...';
      }
      
      // Note: We don't need JavaScript-based success handling since Shopify handles form submission
      // The success state is handled by Liquid templating on page reload
    });
    
    // Show error message function
    function showErrorMessage(message) {
      // Remove existing error messages
      const existingError = newsletterForm.querySelector('.temp-error-message');
      if (existingError) {
        existingError.remove();
      }
      
      // Create new error message
      const errorDiv = document.createElement('div');
      errorDiv.className = 'temp-error-message mt-2';
      errorDiv.innerHTML = `
        <div class="error-message p-3 rounded-lg" style="background-color: rgba(220, 53, 69, 0.1); border: 1px solid #dc3545; color: #dc3545;">
          <div class="flex items-center gap-2">
            <svg class="w-5 h-5 flex-shrink-0" fill="currentColor" viewBox="0 0 20 20">
              <path fill-rule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7 4a1 1 0 11-2 0 1 1 0 012 0zm-1-9a1 1 0 00-1 1v4a1 1 0 102 0V6a1 1 0 00-1-1z" clip-rule="evenodd"/>
            </svg>
            <span>${message}</span>
          </div>
        </div>
      `;
      
      // Insert after input section
      if (inputSection) {
        inputSection.insertAdjacentElement('afterend', errorDiv);
        
        // Auto-hide after 5 seconds
        setTimeout(() => {
          if (errorDiv && errorDiv.parentNode) {
            errorDiv.remove();
          }
        }, 5000);
      }
    }
  }
});